import React, { memo } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { useLangFile } from '../../../context/LanguageContext';

interface BulkPrescriptionReturnToOverviewDialogProps {
  closeDialog: () => void;
  open: boolean;
  resetBulkPrescriptionJobs: () => void;
}

const BulkPrescriptionReturnToOverviewDialog: React.FC<
  BulkPrescriptionReturnToOverviewDialogProps
> = (props) => {
  const LangFile = useLangFile();

  const onConfirm = () => {
    props.resetBulkPrescriptionJobs();
    props.closeDialog();
  };

  return (
    <Dialog open={Boolean(props.open)} fullWidth maxWidth={'md'}>
      <DialogTitle>{LangFile.BulkPrescriptionReturnToOverviewDialog.title}</DialogTitle>

      <DialogContent style={{ overflow: 'hidden' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {LangFile.BulkPrescriptionReturnToOverviewDialog.warning}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onConfirm()} color="secondary" variant="outlined">
          {LangFile.BulkPrescriptionReturnToOverviewDialog.reset}
        </Button>
        <Button onClick={() => props.closeDialog()} color={'primary'} variant={'contained'}>
          {LangFile.BulkPrescriptionReturnToOverviewDialog.cancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(BulkPrescriptionReturnToOverviewDialog);
